export default __webpack_public_path__ + "static/media/Tiger's Boots of the Elder Bond.baa8204e.jpg";